import React from 'react';
import parse from 'html-react-parser';

import { requestGet, } from '../../../../../modules/request'
import { DataTable, Spinner, } from '../../../../Shared/index'
import ScoreColor from '../../modules/score_color';
import useScaledTableColumnWidths from '../../../../Shared/hooks/useScaledTableColumnWidths';

interface QuestionInterface {
  instructions: string;
  prompt: string;
  question_id: number;
  question_number: number;
  question_uid: string;
  score: number;
}

const QuestionReport = ({ match, }) => {
  const containerRef = React.useRef<HTMLElement>(null);

  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null)

  const columnWidths = useScaledTableColumnWidths({
    additionalWidthRestrictions: 34,
    columnWidths: [
      { minWidth: 90, width: 90 },
      { minWidth: 90, width: 90 },
      { minWidth: 160, width: 480 },
      { minWidth: 160, width: 506 },
    ],
    containerRef,
    maxTableWidth: 1200,
    minTableWidth: 500,
  });

  const headers = [
    {
      name: 'Score',
      attribute: 'score',
      sortAttribute: 'scoreNumber',
      width: columnWidths['90w-90min'],
      isSortable: true,
      noTooltip: true,
      rowSectionClassName: 'center-content',
      headerClassName: 'center-content'
    },
    {
      name: 'No.',
      attribute: 'questionNumber',
      sortAttribute: 'questionNumber',
      width: columnWidths['90w-90min'],
      isSortable: true,
      noTooltip: true,
      rowSectionClassName: 'center-content',
      headerClassName: 'center-content'
    },
    {
      name: 'Instructions',
      attribute: 'instructions',
      sortAttribute: 'instructions',
      width: columnWidths['480w-160min'],
      isSortable: true,
      noTooltip: true,
      rowSectionClassName: 'allow-wrap'
    },
    {
      name: 'Prompt',
      attribute: 'prompt',
      sortAttribute: 'prompt',
      width: columnWidths['506w-160min'],
      isSortable: true,
      noTooltip: true,
      rowSectionClassName: 'allow-wrap'
    },
  ]

  const { params, } = match
  const { unitId, activityId, classroomId, } = params

  React.useEffect(() => {
    requestGet(`/teachers/progress_reports/question_view/classroom/${classroomId}/activity/${activityId}/unit/${unitId}`, (response) => {
      setQuestions(response.data)
    })
  }, [])

  if (!questions) {
    return (<div className="container"><Spinner /></div>)
  }

  const rows = questions.map((question) => {
    const { instructions, prompt, question_id, question_number, score } = question
    const formattedPrompt = prompt ? <span>{parse(prompt)}</span> : ''

    return {
      key: question_id,
      id: question_id,
      score: <span className={ScoreColor(score)}>{score || score === 0 ? `${score}%` : 'N/A'}</span>,
      scoreNumber: score,
      questionNumber: question_number,
      instructions,
      prompt: formattedPrompt
    }
  })

  return (
    <main className="container question-report" ref={containerRef}>
      <DataTable
        defaultSortAttribute='scoreNumber'
        defaultSortDirection='descending'
        headers={headers}
        reportingFormat={true}
        rows={rows}
      />
    </main>
  )
}

export default QuestionReport
